export class DialogResult {
    Result: boolean;
    Text: string;
    Payload: any;
}